import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {List} from 'immutable';
import RequestPasswordResetForm from './RequestPasswordResetForm';
import toastr from 'toastr';
import {withRouter} from 'react-router';
import {
  MainContent,
  Page,
  PageBody,
} from '../../layout/components';
import React, {Component, PropTypes} from 'react';
import {
  requestPasswordReset,
  resetRequestPasswordResetForm,
  setRequestPasswordResetForm,
} from '../actions';
import {handleApiError} from '../../shared/services';

class RequestPasswordResetPage extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentDidMount() {
    this.props.resetRequestPasswordResetForm();
  }

  handleFieldChange(event) {
    const {name, value} = event.target;
    this.props.handleFieldChange(name, value);
  }

  handleSubmit(event) {
    event.preventDefault();

    const {handleSubmit, model, router} = this.props;

    handleSubmit(model)
      .then(() => {
        toastr.success(`Password reset instructions sent to <strong>${model.get('email')}</strong>.`, 'Password Reset', {timeout: 10000, allowHtml: true});
        router.push('/login');
      })
      .catch(error => {
        if (error.response && error.response.status === 404) {
          handleApiError(error, router, 'Could not find account with provided email, please check the spelling and try again.', 'Error');
        } else {
          handleApiError(error, router, 'An error occurred while attempting to request a password reset.', 'Error');
        }
      });
  }

  render() {
    const {model, submitting} = this.props;

    return (
      <Page pageClassName="request-password-reset-page">
        <RequestPasswordResetForm
          model={model}
          submitting={submitting}
          onFieldChange={this.handleFieldChange}
          onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

RequestPasswordResetPage.propTypes = {
  handleFieldChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  model: PropTypes.object.isRequired,
  resetRequestPasswordResetForm: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  const {requestPasswordReset} = state.features.passwordManagement.pages;

  return {
    model: requestPasswordReset.get('model'),
    submitting: requestPasswordReset.get('submitting'),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    resetRequestPasswordResetForm,
    handleFieldChange: setRequestPasswordResetForm,
    handleSubmit: requestPasswordReset,
  }
)(RequestPasswordResetPage));



// WEBPACK FOOTER //
// ./app/features/passwordManagement/components/RequestPasswordResetPage.js